import { size12, size16, size24, size32, size64 } from '../theme/scale';
export const GUTTER_SIZES_MAP = {
  0: 0,
  sm: size12,
  md: size16,
  lg: size24,
  xl: size32,
  xxl: size64
};
export const MIN_COLUMNS = 1;
export const MAX_COLUMNS = 12;
export const BREAKPOINTS = {
  desktop: {
    containerSize: '71.25rem',
    margin: size24,
    gutter: size24
  },
  tablet: {
    containerSize: '45rem',
    margin: size16,
    gutter: size16
  },
  mobile: {
    containerSize: '33.75rem',
    margin: size12,
    gutter: size12
  }
};
export const GRID_TYPES = {
  GRID: 'grid',
  FLEX: 'flex'
};
//# sourceMappingURL=config.js.map